app.controller('OrderQuoteExtraController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $scope.item_alerts = {};
    $scope.form_error_message = "You must provide a title and a price to save an Extra";

    function createQuoteItemList() {
        const itemList = [];
        if ($rootScope.model.account.user_data) {
            for (let quoteItemID in $rootScope.model.account.user_data.quote_items) {
                itemList.push($rootScope.model.account.user_data.quote_items[quoteItemID]);
            }
        }
        return itemList;
    }

    $scope.list_model = new $rootScope.model_constructor.ListModel({
        item_list: createQuoteItemList()
    });
    const unbindAccountDataReplaced = $rootScope.$on('account_data_replaced', function () {
        $scope.list_model.cloneList(createQuoteItemList());
    });

    $scope.$on('$destroy', unbindAccountDataReplaced)

    $scope.new_quote_extra = {};

    $scope.saveNewQuoteExtra = function (validateFormCallback) {

        $rootScope.service.order_quote.saveNewQuoteExtra($scope.new_quote_extra, function (success, quoteExtra, messages) {
            if (success) {
                $scope.list_model.item_list.unshift(quoteExtra);
                $rootScope.model.account.user_data.quote_items[quoteExtra._id] = quoteExtra;
                $scope.new_quote_extra = {};
            }
            validateFormCallback(success, messages);
        })
    };

    $scope.deleteQuoteExtra = function (quoteExtraID) {
        delete $scope.item_alerts[quoteExtraID];

        $rootScope.service.order_quote.deleteQuoteExtra(quoteExtraID, function (success, data, messages) {
            if (success) {
                for (let i = 0; i < $scope.list_model.item_list.length; i++) {
                    if ($scope.list_model.item_list[i]._id === quoteExtraID) {
                        $scope.list_model.item_list.splice(i, 1);
                        break;
                    }
                }
                delete $rootScope.model.account.user_data.quote_items[quoteExtraID];
            }
            $scope.item_alerts[quoteExtraID] = messages;
        });
    }

    $scope.addQuoteExtraToCurrentQuote = function (quoteExtra) {
        delete $scope.item_alerts[quoteExtra._id];

        $rootScope.service.order_quote.addQuoteExtraToCurrentQuote(quoteExtra, function (success, data, messages) {
            $scope.item_alerts[quoteExtra._id] = messages;
        });
    };

    $scope.startNewQuote = function () {
        $rootScope.service.order.startNewOrder(true);
        $state.go('myba.dashboard');
    }

}]);